<!-- 氏名変更用のパネル -->
<template lang="html">
  <div id="fullnameChangePanel">
    <span>氏名の変更</span>
    <label>新しい氏名:
      <input type="text" v-model="new_fullname" />
    </label>
    <label>新しいフリガナ:
      <input type="text" name="kana" v-model="new_kana">
    </label>
    <button @click="changeFullnameLocal">氏名を変更</button>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      new_fullname: this.current_fullname,
      new_kana: this.current_kana
    }
  },
  props: [
    'user_id',
    'current_fullname',
    'current_kana'
  ],
  methods: {
    ...mapActions([
      'changeFullname'
    ]),
    checkKana () {
      if (!this.new_kana.match(/^[ァ-ヴ]+$/)) {
        return false
      }
      return true
    },
    changeFullnameLocal () {
      if (!this.checkKana()) {
        alert('フリガナは全角カナのみで入力してください')
        return
      }
      this.changeFullname({
        id: this.user_id,
        newFullname: this.new_fullname,
        newKana: this.new_kana
      }).then((res) => {
        if (res) {
          this.$emit('changed')
          alert('氏名の変更に成功しました.')
        }
      })
    }
  }
}
</script>

<style lang="css" scoped>
label {
  display: block;
}
#fullnameChangePanel {
  width: 900px;
  margin-top: 10px;
  padding-top:10px;
  margin-left: auto;
  margin-right: auto;
  border-style: solid;
  border-color: #E69200;
  border-left: none;
  border-right: none;
  border-bottom: none;
}
</style>



// WEBPACK FOOTER //
// FullnameChangePanel.vue?12f4d977